module.exports = __webpack_public_path__ + "img/archive-tick.b15f1185.svg";